import { inject, Injectable, signal } from '@angular/core';
import { EMPTY } from 'rxjs';
import { FeedbackContext, UserFeedbackType } from './domain/entities/feedback-context.type';
import { QuickFeedbackApiService } from './domain/quick-feedback.api.service';

@Injectable({
    providedIn: 'root',
})
export class QuickFeedbackService {
    readonly #quickFeedbackApiService = inject(QuickFeedbackApiService);
    showQuickFeedback = signal<boolean>(false);
    quickFeedbackContext = signal<FeedbackContext | null>(null);

    setFeedbackScoreForTakeoffs(score: 0 | 1, feedbackText: string) {
        const context = this.quickFeedbackContext();
        if (!context || !context.metadata) return EMPTY;

        return this.#quickFeedbackApiService.setFeedbackScoreForPlanAutoMeasure(
            score,
            context.metadata?.estimateId,
            context.id,
            feedbackText
        );
    }

    setFeedbackScore(score: 0 | 1, feedbackText: string) {
        const context = this.quickFeedbackContext();
        if (!context) return EMPTY;

        switch (context.type) {
            case UserFeedbackType.AI_REVIEW:
                if (!context.metadata?.estimateId) return EMPTY;
                return this.#quickFeedbackApiService.setFeedbackInput({
                    estimateId: context.metadata.estimateId,
                    type: UserFeedbackType.AI_REVIEW,
                    rating: score,
                    feedback: feedbackText,
                    referenceId: this.quickFeedbackContext()?.id,
                });

            case UserFeedbackType.SMART_ESTIMATE:
                return this.#quickFeedbackApiService.setFeedbackInput({
                    estimateId: context.id,
                    type: UserFeedbackType.SMART_ESTIMATE,
                    rating: score,
                    feedback: feedbackText,
                });
            default:
                return EMPTY;
        }
    }

    reset() {
        this.showQuickFeedback.set(false);
        this.quickFeedbackContext.set(null);
    }
}
